module.exports = __webpack_public_path__ + "js/1.70f23e48.worker.js"